<script setup lang="ts">
import LinksPage from '../features/links/LinksPage.vue';
</script>

<template>
  <LinksPage />
</template>
